export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  body: string | null;
  data: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export function notificationTypeLabel(type: string): string {
  return type.replaceAll("_", " ");
}

/** Resolve in-app path for a notification tap. Collection links require the module. */
export function resolveNotificationPath(
  notification: Pick<NotificationItem, "type" | "data">,
  opts?: { collectionEnabled?: boolean },
): string | null {
  const data = notification.data;
  if (!data || typeof data !== "object") return null;

  const tradeId = data.tradeId;
  if (typeof tradeId === "string") {
    return opts?.collectionEnabled === false ? null : "/inventory?tab=trades";
  }

  const orderId = data.orderId;
  if (typeof orderId === "string") {
    if (notification.type === "raffle_won" || notification.type === "auction_won") {
      return `/checkout/order/${orderId}`;
    }
    return `/orders/${orderId}`;
  }

  return null;
}
